import { Box } from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_ASSOCIATION } from "@raiden/library/constants/posts";
import { PostCard } from "../../../../components/Posts/Card";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Post").Post} post
 * @property {boolean} isFirst
 * @property {import("react-hook-form").UseFormSetValue<{}>} setValue
 */
/**
 * @param {Props & import("@chakra-ui/react").Button} props
 */
export function Item({ post, isFirst, setValue, ...otherProps }) {
  /** @type {import("@chakra-ui/system").ResponsiveValue<number>} */
  const imageRatio =
    post.type === POSTS_TYPE_VALUE_ASSOCIATION
      ? 578 / 108
      : isFirst
      ? { base: 277 / 156, lg: 578 / 443 }
      : 277 / 156;

  return (
    <Box
      w="inherit"
      gridColumn={{
        base: "initial",
        lg: isFirst ? "span 2" : undefined,
      }}
      gridRow={{
        base: "initial",
        lg: isFirst ? "span 2" : undefined,
      }}
      key={post.id}
      {...otherProps}>
      <PostCard
        post={post}
        imageRatio={imageRatio}
        key={post.id}
        setValue={setValue}
      />
    </Box>
  );
}
